import axios from 'axios';

const API_BASE_URL = 'https://apiservices.bookingwhizz.com/api';

/**
 * Email OTP API Service
 * Handles Email OTP sending and verification
 */

/**
 * Send Email OTP
 * @param {Object} params - Request parameters
 * @param {string} params.email - Email address
 * @param {string} params.partnerKey - Partner API Key from accommodationGroupDetail
 * @returns {Promise<Object>} Response from Email OTP API
 */
export const sendEmailOtp = async (params) => {
  try {
    const { email, partnerKey } = params;

    if (!email) {
      throw new Error('Email is required');
    }

    if (!partnerKey) {
      throw new Error('Partner API Key is required');
    }

    const formData = new FormData();
    formData.append('email', email);
    formData.append('autoRegister', '1');

    const response = await axios.post(
      `${API_BASE_URL}/member/code/send`,
      formData,
      {
        headers: {
          'Partner-Api-Key': partnerKey,
          'Accept': 'application/json'
        },
        timeout: 30000
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to send OTP');
    } else if (error.request) {
      throw new Error('Network error: Please check your internet connection');
    } else {
      throw new Error(error.message || 'An error occurred while sending OTP');
    }
  }
};

/**
 * Verify Email OTP code
 * @param {Object} params - Request parameters
 * @param {string} params.email - Email address
 * @param {string} params.code - OTP code entered by user
 * @param {string} params.partnerKey - Partner API Key from accommodationGroupDetail
 * @returns {Promise<Object>} Response from Email OTP verify API
 */
export const verifyEmailOtp = async (params) => {
  try {
    const { email, code, partnerKey } = params;

    if (!email) {
      throw new Error('Email is required');
    }

    if (!code) {
      throw new Error('OTP code is required');
    }

    if (!partnerKey) {
      throw new Error('Partner API Key is required');
    }

    const formData = new FormData();
    formData.append('email', email);
    formData.append('code', code);
    formData.append('autoRegister', '1');
    formData.append('quickSignUp', '1');
    formData.append('sourceId', '56');

    const response = await axios.post(
      `${API_BASE_URL}/member/code/check`,
      formData,
      {
        headers: {
          'Partner-Api-Key': partnerKey,
          'Accept': 'application/json'
        },
        timeout: 30000
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data?.message || error.response.data?.error || 'OTP verification failed');
    } else if (error.request) {
      throw new Error('Network error: Please check your internet connection');
    } else {
      throw new Error(error.message || 'An error occurred during OTP verification');
    }
  }
};
